<script>
import { defineComponent, inject, computed } from "vue";
import "@css/index.css";
import { navAndFooter } from "@project/api/nav-and-footer/v1";
import Column from "@kit/components/Column.vue";
import { useRoute } from "vue-router";
import { getCurrentYear, cmsasset } from "@kit/utils/Formats";

export default defineComponent({
  name: "Footer",
  setup() {
    const hydrate = inject("hydrate");
    const themer = inject("themer");
    const route = useRoute();

    const { prefetch } = hydrate({
      prefetch: ["navAndFooter"],
    });

    const navAndFooter = computed(() => {
      return prefetch.value && prefetch.value.navAndFooter
        ? prefetch.value.navAndFooter
        : null;
    });

    const okToShow = computed(() => {
      return route.name != "contact-us" && route.name != "gtfsrt";
    });

    return { navAndFooter, okToShow, getCurrentYear, cmsasset };
  },
  components: {
    Column,
  },
});
</script>

<style>
.footer-white-text {
  color: white !important;
}
.footer-ride-humboldt-width {
  width: 40% !important;
}
@media (max-width) {
  .footer-ride-humboldt-width {
    width: 100% !important;
  }
}
.footer-container {
  padding-top: 80px !important;
}
.footer-container a {
  color: white !important;
  font-weight: normal;
}
.footer-container a:hover {
  text-decoration: underline;
}
.footer-container ul {
  list-style-type: none;
}
</style>

<template>
  <footer class="sb sb-v sb-g20 footer-white-text footer-container" v-if="navAndFooter">
    <Column tag="div" ltP="100" ltT="100" ltD="90" gtB="1000" gtH="1200" class="sb-v">
      <div class="sb sb-h sb-ltm-h2v sb-uniform-3" style="z-index: 3">
        <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_1"></div>
        <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_2"></div>
        <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_3"></div>
      </div>
      <div class="sb sb-h sb-align-ch" style="z-index: 2">
        <p class="sb sb-text footer-white-text">
          © {{ getCurrentYear() }} Humboldt Transit
        </p>
      </div>
    </Column>

    <img
      :class="navAndFooter.footer_background_image_classes"
      :style="`z-index:1; ${navAndFooter.footer_background_image_style}`"
      :alt="navAndFooter.footer_background_image_aria"
      :src="cmsasset(navAndFooter.footer_background_image.guid)"
    />
  </footer>
  <footer v-else></footer>
</template>
